import { defineMessages } from 'react-intl';

export const ratingMessages = defineMessages({
  newRatingStarsHint: {
    defaultMessage: '1 (Mangelhaft) - 5 (Super)*',
    id: 'ratings.new-rating.stars-hint',
  },
  newRatingStarsHeadlineRatingDefault: {
    defaultMessage: 'Wie findest du das Produkt?',
    id: 'ratings.new-rating.stars-headline-default',
  },
  newRatingStarsHeadlineRating1: {
    defaultMessage: 'Mangelhaft',
    id: 'ratings.new-rating.stars-headline-rating1',
  },
  newRatingStarsHeadlineRating2: {
    defaultMessage: 'Nicht so gut',
    id: 'ratings.new-rating.stars-headline-rating2',
  },
  newRatingStarsHeadlineRating3: {
    defaultMessage: 'Okay',
    id: 'ratings.new-rating.stars-headline-rating3',
  },
  newRatingStarsHeadlineRating4: {
    defaultMessage: 'Gut',
    id: 'ratings.new-rating.stars-headline-rating4',
  },
  newRatingStarsHeadlineRating5: {
    defaultMessage: 'Super',
    id: 'ratings.new-rating.stars-headline-rating5',
  },
  newRatingRatingValueError: {
    defaultMessage: 'Du musst einen Wert für die Gesamtbewertung eingeben.',
    id: 'ratings.new-rating.rating-value-error',
  },
  newRatingEditRating: {
    defaultMessage: 'Bewertung bearbeiten',
    id: 'ratings.new-rating.edit-rating',
  },
  newRatingSubmitRating: {
    defaultMessage: 'Bewertung abgeben',
    id: 'ratings.new-rating.submit-rating',
  },
  newRatingShowRatingPreview: {
    defaultMessage: 'Weiter zur Vorschau',
    id: 'ratings.new-rating.show-rating-preview',
  },
  newRatingSubmitSuccess: {
    defaultMessage:
      'Alle Bewertungen werden geprüft. In 3-5 Werktagen wird deine Bewertung für alle Kunden angezeigt.',
    id: 'ratings.new-rating.submit-success',
  },
  newRatingSubmitSuccessNotification: {
    defaultMessage: 'Bewertung erfolgreich abgeschickt. Vielen Dank!',
    id: 'ratings.new-rating.submit-success-notification',
  },
  newRatingSubmitErrorNotification: {
    defaultMessage: 'Bewertung konnte nicht abgeschickt werden!',
    id: 'ratings.new-rating.submit-error-notification',
  },
  buttonLabel: {
    defaultMessage: 'Verfasse eine Bewertung',
    id: 'ratings.new-rating.label',
  },
  dialogTitle: {
    defaultMessage: 'Bewerte das Produkt',
    id: 'ratings.new-rating.modal-headline.create',
  },
  newRatingLabel: {
    defaultMessage: 'Verfasse eine Bewertung',
    id: 'ratings.new-rating.label',
  },
  newRatingMandatoryFieldsHint: {
    defaultMessage: 'Die mit * markierten Felder sind Pflichtfelder.',
    id: 'rating.new-rating.mandatory-fields-hint',
  },
  newRatingPreviewHeadline: {
    defaultMessage: 'Hier kannst du deine Bewertung nochmal überprüfen',
    id: 'ratings.new-rating.preview-headline',
  },
  newRatingSubmitError: {
    defaultMessage:
      'Deine Bewertung konnte leider nicht übermittelt werden. Bitte versuche es erneut.',
    id: 'ratings.new-rating.submit-error',
  },
  reviewLabel: {
    defaultMessage: 'Ausführliche Bewertung*',
    id: 'ratings.new-rating.form.review-label',
  },
  reviewPlaceholder: {
    defaultMessage: 'Erzähle uns etwas über das Produkt.',
    id: 'ratings.new-rating.form.review-placeholder',
  },
  headlineRating: {
    defaultMessage: 'Überschrift',
    id: 'ratings.new-rating.form.headline',
  },
  headlinePlaceholder: {
    defaultMessage: 'Klasse Produkt!',
    id: 'ratings.new-rating.form.headline-placeholder',
  },
  nicknameLabel: {
    defaultMessage: 'Name*',
    id: 'ratings.new-rating.form.nickname-label',
  },
  nicknamePlaceholder: {
    defaultMessage: 'Dein (Spitz-)Name',
    id: 'ratings.new-rating.form.nickname-placeholder',
  },
  nicknameError: {
    defaultMessage: 'Du musst einen Nicknamen eingeben.',
    id: 'ratings.new-rating.reviewer-name-error',
  },
  newRatingTermsLinkLabel: {
    defaultMessage: 'Nutzungsbedingungen',
    id: 'ratings.new-rating.terms-link.label',
  },
  newRatingTermsLabel: {
    defaultMessage:
      'Ich habe die <link>Nutzungsbedingungen</link> gelesen und erkläre mich damit einverstanden.*',
    id: 'ratings.new-rating.terms-link.pre',
  },
  advantageAriaLabel: {
    defaultMessage: 'Vorteil hinzufügen',
    id: 'ratings.new-rating.form.advantage-arialabel',
  },
  advantageLabel: {
    defaultMessage: 'Vorteile',
    id: 'ratings.new-rating.form.advantage-label',
  },
  advantagePlaceholder: {
    defaultMessage: 'z.B. weich',
    id: 'ratings.new-rating.form.advantage-placeholder',
  },
  advantageError: {
    defaultMessage: 'Du musst mindestens einen Vorteil angeben.',
    id: 'ratings.new-rating.review-advantages-error',
  },

  disadvantageAriaLabel: {
    defaultMessage: 'Nachteil hinzufügen',
    id: 'ratings.new-rating.form.disadvantage-arialabel',
  },
  disadvantageLabel: {
    defaultMessage: 'Nachteile',
    id: 'ratings.new-rating.form.disadvantage-label',
  },
  disadvantagePlaceholder: {
    defaultMessage: 'z.B. kratzig',
    id: 'ratings.new-rating.form.disadvantage-placeholder',
  },
  disadvantageError: {
    defaultMessage: 'Du musst mindestens einen Nachteil angeben.',
    id: 'ratings.new-rating.review-disadvantages-error',
  },
  newRatingAdvantagesHint: {
    defaultMessage:
      'Durch deine Erfahrung hilfst du anderen Kunden, sich für das richtige Produkt zu entscheiden. Füge Vor- und Nachteile über das "+" Icon hinzu.',
    id: 'ratings.new-rating.advantages-hint',
  },
});
